import React from 'react';
import classes from './CircleText.module.css';

export const CircleText = () => {
    return (
        <figure className={classes.CircleText} />
    );
};